module.exports = __webpack_public_path__ + "static/media/alert.120f75c7.svg";